import React from 'react';

/**
 * Scrolling services marquee — shared across LandingPage, FreeGuidePage, EbookPage.
 * The CSS for `.marquee-section` / `.marquee` / `.marquee-content` lives in LandingPage.css.
 */
const ServicesMarquee = () => (
  <div className="marquee-section" data-testid="services-marquee">
    <div className="marquee">
      <div className="marquee-content">
        <span>Cultural Needs Assessment</span>
        <span>•</span>
        <span>Cultural Competency Consulting</span>
        <span>•</span>
        <span>Organizational Case Management Services</span>
        <span>•</span>
        <span>Concierge Case Management Services</span>
        <span>•</span>
        <span>Culturally Responsive Coaching</span>
        <span>•</span>
        <span>Where Culture Meets Healing</span>
        <span>•</span>
      </div>
      <div className="marquee-content" aria-hidden="true">
        <span>Cultural Needs Assessment</span>
        <span>•</span>
        <span>Cultural Competency Consulting</span>
        <span>•</span>
        <span>Organizational Case Management Services</span>
        <span>•</span>
        <span>Concierge Case Management Services</span>
        <span>•</span>
        <span>Culturally Responsive Coaching</span>
        <span>•</span>
        <span>Where Culture Meets Healing</span>
        <span>•</span>
      </div>
    </div>
  </div>
);

export default ServicesMarquee;
